/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import createTpInvitation from "../components/trustpilot";
import { paymentResult } from "../shop/connect";
import { updateCart } from "../shop/render";
import { setCookie } from "../util/dom";
var receipt = {
  init: function init() {
    // console.log("DEBUG: window.tokens.debug", window.tokens.debug);
    var body = $("body");
    var loaderClass = 'is-loading';
    body.addClass(loaderClass);
    if (!window.tokens.debug) {
      paymentResult().then(function (data) {
        // Trust pilot
        if (data.data && data.data.order) createTpInvitation(data.data.order || {});
        setCookie('receiptRendered');
        updateCart({
          items: [],
          totals: {
            totalQuantity: 0,
            itemsTotalPrice: 0,
            shippingPrice: 0,
            grandTotalPrice: 0
          }
        }, null, null);
        var hasError = data.hasOwnProperty('type') && data.type === 'SELECTION_FAILED';
        body.removeClass(loaderClass);

        // Render error message
        var receiptHeader = $('.js-receiptHeader');
        if (hasError && receiptHeader.length) {
          var title = receiptHeader.find('.title');
          if (title.length && title.data('error')) title.html(title.data('error'));
          var content = receiptHeader.find('.content');
          if (content.length && content.data('error')) content.html(content.data('error'));
        }
      });
    } else {
      body.removeClass(loaderClass);
      createTpInvitation({
        order: 0,
        address: {
          lastname: 'Lastname',
          firstname: 'Firstname'
        }
      });
    }
  }
};
export default receipt;


// WEBPACK FOOTER //
// ./scripts/routes/receipt.js